import { MainHeaderTemplate } from 'ui/src/templates';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import globalState from 'ui/src/state/globalState';
import '../styles/css/style.scss';
import mainState from 'state/mainState';
import UserApi from 'api/UserApi';
import ApiMapper from 'constant/ApiMapper';
import env from 'config/env';
import { setLogout } from 'ui/src/utils/SetUserInfo';
import EditPassword from 'ui/src/components/EditPassword';

const MAIN_URL = `${env().MAIN_PATH}`;
const SSOURL = `${env().SSO_URL}`;

const HeaderWrap = () => {
  const location = useLocation();
  const { UserInformation } = useRecoilValue(globalState);
  const [userState, setUserState] = useRecoilState(globalState);
  const [main, setMain] = useRecoilState(mainState);

  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const svcMapper = ApiMapper.SERVICE_AUTH;

  const handlePasswordChange = async (currentPassword: string, newPassword: string) => {
    const resp = await UserApi.UpdatePassword(mapper.UPDATE_PW, newPassword, currentPassword);

    return resp;
  };

  const handleUserNameClick = () => {
    if (UserInformation.login_type === 'login' && UserInformation.use_yn === 'Y') {
      setPasswordModalOpen(true);
    }
  };

  // admin 페이지 여부 확인
  const isAdminPage = location.pathname.startsWith('/admin');

  const mapper = ApiMapper.AUTH;

  //토큰 대신 쿠키 삭제 버전
  const logoutApi = async () => {
    await UserApi.Logout({ url: svcMapper.LOGOUT }).then((response) => {
      setLogout(setUserState);
      console.log(response);
    });
  };

  const logoutFunc = () => {
    logoutApi();
    setLogout(setUserState);
  };

  useEffect(() => {
    console.log(window.location.pathname);
    if (window.location.pathname === '/main/main/logout' || window.location.pathname === '/main/logout') {
      logoutFunc();
    }
  }, []);

  return (
    <div>
      <MainHeaderTemplate
        backgroundColor={isAdminPage ? '#ffffff' : '#f3f2ec'}
        userInfo={UserInformation}
        setMain={setMain}
        setUserState={setUserState}
        logoutApi={logoutApi}
        homeUrl={MAIN_URL}
        SSOURL={SSOURL}
        userState={userState}
        onUserNameClick={handleUserNameClick}
      />
      <EditPassword
        open={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        onSubmit={handlePasswordChange}
      />
    </div>
  );
};

export default HeaderWrap;
